
import { Options, Vue } from "vue-class-component";
import { ref } from "vue";
import * as echarts from "echarts";
import {
  dispatchGetReportStat,
  dispatchGetVisitStatistics,
  dispatchGetVisitStatTrend,
  dispatchGetMonitorTrend,
  dispatchGetMonitorList,
  dispatchGetMonitorUploadTrend,
  dispatchGetMonitorUploadList,
} from "@/store/project/actions";
import { store } from "@/store";
import { getLocalProject, dateConversion } from "@/utils";
import {
  readReportStat,
  readVisitStatistics,
  readMonitorList,
  readVisitStatTrend,
  readMonitorTrend,
  readMonitorUploadTrend,
  readMonitorUploadList,
} from "@/store/project/getters";
@Options({
  components: {},
})
export default class OperationalData extends Vue {
  public localProject = Number(getLocalProject());
  public loading = false;
  public loading1 = false;
  public record = 10; //记录条数
  public statistics = 10; //统计条数
  public record_input = ""; //记录搜索
  public statistics_input = ""; //统计搜索
  public currentPage1 = 1;
  public currentPage2 = 1;
  public start_date = this.getDay(-6);
  public end_date = this.getDay(0);
  public getDate = "";
  public getDate2 = "";

  // 时间选择器
  public Timevalue = ref("");
  public Timevalue2 = ref("");
  public defaultTime = ref([
    new Date(2000, 1, 1, 0, 0, 0),
    new Date(2000, 2, 1, 23, 59, 59),
  ]); // '00:00:00', '23:59:59'

  //图表
  public get TrendChart() {
    let trend_chart: any = document.getElementById("trend_chart");
    echarts.dispose(trend_chart);
    let PerformanceLineChart = echarts.init(trend_chart);
    let option;
    option = {
      tooltip: {
        trigger: "axis",
      },
      // legend: {
      //   x: "center",
      //   y: "bottom",
      //   data: ["平台页面浏览量", "平台用户访问量"],
      // },
      grid: {
        left: "3%",
        top: "20%",
        bottom: "15%",
        right: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
          magicType: { show: true, type: ["line", "bar"] },
        },
      },
      xAxis: {
        type: "category",
        // boundaryGap: false,
        data: this.getMonitorTrend.date_list,
      },

      yAxis: [
        {
          name: "API平均耗时",
          type: "value",
          axisLabel: {
            formatter: "{value}ms",
          },
        },
      ],
      series: [
        {
          name: "",
          type: "line",
          data: this.getMonitorTrend.avg_times,
          lineStyle: {
            normal: {
              type: "solid",
            },
          },
        },
      ],
    };

    PerformanceLineChart.setOption(option);
    PerformanceLineChart.getZr().on("click", (params) => {
      var pointInPixel = [params.offsetX, params.offsetY];
      if (PerformanceLineChart.containPixel("grid", pointInPixel)) {
        /*此处添加具体执行代码*/

        var pointInGrid = PerformanceLineChart.convertFromPixel(
          { seriesIndex: 0 },
          pointInPixel
        );
        //X轴序号
        var xIndex = pointInGrid[0];

        //获取当前图表的option
        var op = PerformanceLineChart.getOption();

        //获得图表中我们想要的数据
        var xDate = op.xAxis[0].data[xIndex];
        this.getDate = xDate;
        this.currentPage1 = 1;
        dispatchGetMonitorList(store, {
          project: this.localProject,
          date: xDate,
          size: this.record,
          page: this.currentPage1,
          api: this.record_input,
        });

        this.getMonitorList;
      }
    });
    return PerformanceLineChart;
  }
  public get TrendChart2() {
    let trend_chart: any = document.getElementById("trend_chart2");
    echarts.dispose(trend_chart);
    let PerformanceLineChart = echarts.init(trend_chart);
    let option;
    option = {
      tooltip: {
        trigger: "axis",
      },
      // legend: {
      //   x: "center",
      //   y: "bottom",
      //   data: ["平台页面浏览量", "平台用户访问量"],
      // },
      grid: {
        left: "3%",
        top: "20%",
        bottom: "15%",
        right: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
          magicType: { show: true, type: ["line", "bar"] },
        },
      },
      xAxis: {
        type: "category",
        // boundaryGap: false,
        data: this.getMonitorUploadTrend.date_list,
      },

      yAxis: [
        {
          name: "上传解析平均耗时",
          type: "value",
          axisLabel: {
            formatter: "{value}秒",
          },
        },
      ],
      series: [
        {
          name: "",
          type: "line",
          data: this.getMonitorUploadTrend.avg_times,
          lineStyle: {
            normal: {
              type: "solid",
            },
          },
        },
      ],
    };

    PerformanceLineChart.setOption(option);
    PerformanceLineChart.getZr().on("click", (params) => {
      var pointInPixel = [params.offsetX, params.offsetY];
      if (PerformanceLineChart.containPixel("grid", pointInPixel)) {
        /*此处添加具体执行代码*/

        var pointInGrid = PerformanceLineChart.convertFromPixel(
          { seriesIndex: 0 },
          pointInPixel
        );
        //X轴序号
        var xIndex = pointInGrid[0];

        //获取当前图表的option
        var op = PerformanceLineChart.getOption();

        //获得图表中我们想要的数据
        var xDate = op.xAxis[0].data[xIndex];
        this.getDate2 = xDate;
        this.currentPage2 = 1;
        dispatchGetMonitorUploadList(store, {
          project: this.localProject,
          date: xDate,
          size: this.statistics,
          page: this.currentPage2,
          api: this.record_input,
        });

        this.getMonitorUploadList;
      }
    });
    return PerformanceLineChart;
  }

  public async mounted() {
    this.loading = true;

    await dispatchGetMonitorTrend(store, {
      start_date: this.start_date,
      end_date: this.end_date,
    });
    await dispatchGetMonitorUploadTrend(store, {
      project: this.localProject,
      start_date: this.start_date,
      end_date: this.end_date,
    });
    dispatchGetMonitorList(store, {
      project: this.localProject,
      date: this.end_date,
      size: this.record,
      page: this.currentPage1,
      api: this.record_input,
    });
    dispatchGetMonitorUploadList(store, {
      project: this.localProject,
      date: this.end_date,
      size: this.statistics,
      page: this.currentPage2,
      api: this.statistics_input,
    });

    await this.TrendChart;
    await this.TrendChart2;
    this.loading = false;
  }

  // 获得统计数据

  // 获得记录数据

  public get getMonitorList() {
    return readMonitorList(store);
  }
  public get getMonitorUploadList() {
    readMonitorUploadList(store).results?.forEach((v) => {
      v.time = dateConversion(v.time);
    });
    return readMonitorUploadList(store);
  }

  public get getMonitorTrend() {
    return readMonitorTrend(store);
  }
  public get getMonitorUploadTrend() {
    return readMonitorUploadTrend(store);
  }

  // 一页显示
  public async showList(show: any) {
    this.loading = true;
    if (show === "statistics_input") {
      dispatchGetMonitorUploadList(store, {
        project: this.localProject,
        date: this.getDate2 === "" ? this.end_date : this.getDate2,
        size: this.statistics,
        page: this.currentPage2,
        api: this.statistics_input,
      });
    } else {
      await dispatchGetMonitorList(store, {
        project: this.localProject,
        date: this.getDate === "" ? this.end_date : this.getDate,
        size: this.record,
        page: this.currentPage1,
        api: this.record_input,
      });
    }
    this.loading = false;
  }
  // 分页
  public async handleCurrentChange(page: any) {
    this.loading = true;
    if (page === "statistics_input") {
      this.loading1 = true;
      dispatchGetMonitorUploadList(store, {
        project: this.localProject,
        date: this.getDate2 === "" ? this.end_date : this.getDate2,
        size: this.statistics,
        page: this.currentPage2,
        api: this.statistics_input,
      });
      this.loading1 = false;
    } else {
      await dispatchGetMonitorList(store, {
        project: this.localProject,
        date: this.getDate === "" ? this.end_date : this.getDate,
        size: this.record,
        page: this.currentPage1,
        api: this.record_input,
      });
    }
    this.loading = false;
  }
  // 序号
  public indexMethod(index: any, val: any) {
    if (val === "statistics_input") {
      return index + 1 + (this.currentPage2 - 1) * this.record;
    } else {
      return index + 1 + (this.currentPage1 - 1) * this.statistics;
    }
  }

  // 搜索
  public async recordSearch(search: any) {
    this.loading = true;
    if (search === "statistics_input") {
      dispatchGetMonitorUploadList(store, {
        project: this.localProject,
        date: this.getDate2 === "" ? this.end_date : this.getDate2,
        size: this.statistics,
        page: this.currentPage2,
        api: this.statistics_input,
      });
    } else {
      await dispatchGetMonitorList(store, {
        project: this.localProject,
        date: this.getDate === "" ? this.end_date : this.getDate,
        size: this.record,
        page: this.currentPage1,
        api: this.record_input,
      });
    }
    this.loading = false;
  }

  // 清空
  public async clearSearch(search: any) {
    this.loading = true;
    this.statistics = 10;
    this.record = 10;
    if (search === "statistics_input") {
      this.statistics_input = "";
      this.currentPage2 = 1;
      dispatchGetMonitorUploadList(store, {
        project: this.localProject,
        date: this.getDate2 === "" ? this.end_date : this.getDate2,
        size: 10,
        page: this.currentPage2,
        api: this.statistics_input,
      });
    } else {
      this.record_input = "";
      this.currentPage1 = 1;
      await dispatchGetMonitorList(store, {
        project: this.localProject,
        date: this.getDate === "" ? this.end_date : this.getDate,
        size: 10,
        page: this.currentPage1,
        api: this.record_input,
      });
    }
    this.loading = false;
  }

  // 获取时间
  public async getTime(type) {
    this.loading = true;
    if (type === "record_input") {
      const start_date = Object.values(this.Timevalue)[0];
      const end_date = Object.values(this.Timevalue)[1];
      await dispatchGetMonitorTrend(store, {
        start_date: start_date,
        end_date: end_date,
      });
      await this.TrendChart;
    }
    if (type === "statistics_input") {
      const start_date = Object.values(this.Timevalue2)[0];
      const end_date = Object.values(this.Timevalue2)[1];
      await dispatchGetMonitorUploadTrend(store, {
        project: this.localProject,
        start_date: start_date,
        end_date: end_date,
      });
      await this.TrendChart2;
    }

    this.loading = false;
  }

  // 最近一周的时间
  public async getTime2(type) {
    this.loading = true;

    if (type === "record_input") {
      await dispatchGetMonitorTrend(store, {
        start_date: this.start_date,
        end_date: this.end_date,
      });
      await this.TrendChart;
    }
    if (type === "statistics_input") {
      await dispatchGetMonitorUploadTrend(store, {
        project: this.localProject,
        start_date: this.start_date,
        end_date: this.end_date,
      });
      await this.TrendChart2;
    }
    this.loading = false;
  }

  // 获取日期
  public getDay(day: any) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  }
  public doHandleMonth(month: any) {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  }
}
